var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightViewEntries(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#00d89a;}.cls-3{fill:#7effaa;}.cls-4{fill:#e1ffe1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.41,
    y: 0.02,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.41,
    y: 0.02,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "weight_view_entries"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217.87,
    y: 1.26,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 107.8,
    y: 75.92,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M379.79,270.39v314a17,17,0,0,1-17.26,16.84H16.08A17,17,0,0,1-1.17,584.42V170.25a17,17,0,0,1,17.25-16.84H259.9a17.7,17.7,0,0,1,5.85,1l112.49,109A16.47,16.47,0,0,1,379.79,270.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.24,263.42H283.18a17.27,17.27,0,0,1-17.43-17.09V154.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.46,
    y: 372.68,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.97 1.42) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.57,
    y: 519.34,
    width: 133.75,
    height: 36.54,
    rx: 12,
    transform: "translate(-4.08 0.95) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 53.9,
    y: 299.6,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.41 1.42) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.01,
    y: 445.77,
    width: 261.49,
    height: 36.54,
    rx: 12,
    transform: "translate(-3.52 1.43) rotate(-0.44)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightViewEntries);
export default __webpack_public_path__ + "static/media/weight_view_entries.262b654ccfcc7acfc50355c79391dbc3.svg";
export { ForwardRef as ReactComponent };